import React, { useEffect, useState } from 'react';
import { createUseStyles } from 'react-jss';
import { useDecoratedAssets, useDepartment, useStorage } from '../../services/Firestore/Resources';
import AssetListSelect from '../../views/Asset/AssetListSelect';
import { Icon } from '../../components/Icon/Icon';
import Input from '../../components/Input/Input';

const useStyles = createUseStyles({
  root: {},
  listContainer: {
    display: 'grid',
    gridTemplateColumns: 'length:30% length:70%',
    gridTemplateRows: 'auto auto',
    gridTemplateAreas: '"header search" "list list"',
  },
  list: {
    gridArea: 'list',
  },
  header: {
    gridArea: 'header',
    justifySelf: 'self-start',
    marginTop: 10,
    marginLeft: 10,
  },
  searchInput: {
    margin: 0,
    width: '300px',
  },
  columnFilter: {
    cursor: 'pointer',
    margin: 10,
  },
  search: {
    gridArea: 'search',
    justifySelf: 'self-end',
    marginTop: 10,
    marginLeft: 10,
    display: 'grid',
    gridTemplateColumns: 'auto auto',
  },
});

const ManifestFindAssetForm = ({ alreadyAddedAssets, user, onAddToManifest }) => {
  const classes = useStyles();
  const [filter, setFilter] = useState('');
  const [columnFilter, setColumnFilter] = useState(false);
  const [assets, assetsLoading] = useDecoratedAssets();
  const [assetsToView, setAssetsToView] = useState([]);
  const [department, departmentLoading] = useDepartment(user.home);
  const [departmentParentId, setDepartmentParentId] = useState(null);
  const [departmentParent, departmentParentLoading] = useStorage(departmentParentId);

  const DepartmentSelection = 0;
  const DepartmentParentSelection = 1;
  const AllSelection = 2;

  const handleFilterChange = (e) => {
    setFilter(e.target.value);
  };
  useEffect(() => {
    if (department) {
      setDepartmentParentId(department.parent);
    }
  }, [department, departmentLoading]);

  let userHasDepartment = !(user.home === '' || !user.home);
  const [assetSelection, setAssetSelection] = useState(
    userHasDepartment ? DepartmentParentSelection : AllSelection,
  );

  useEffect(() => {
    if (assets) {
      setAssetsToView(assets.filter((v) => filterAssetOnLineage(v.storage) && !v.deleted));
    }
  }, [!assetsLoading, assetSelection, assets, department]);

  const filterAssetOnLineage = (storage) => {
    if (!userHasDepartment) {
      return true;
    }
    if (assetSelection === AllSelection) {
      return true;
    }
    if (storage === null || storage === undefined) {
      return false;
    }
    switch (assetSelection) {
      case DepartmentSelection:
        return storage.lineage.includes(user.home);
      case DepartmentParentSelection:
        if (department) {
          return storage.lineage.includes(department.parent);
        }
        return true;
      default:
        return true;
    }
  };
  if (!assets || departmentLoading || assetsLoading || departmentParentLoading) {
    return 'Loading';
  }

  let searchLocation = 'Search all assets';
  if (userHasDepartment) {
    if (assetSelection === DepartmentSelection) {
      searchLocation = 'Search only ' + department.name;
    } else if (assetSelection === DepartmentParentSelection) {
      searchLocation = 'Search on ' + departmentParent?.name;
    }
  }

  return (
    <div className={classes.root}>
      <div className={classes.listContainer}>
        <div className={classes.search}>
          <Input
            className={classes.searchInput}
            placeholder={searchLocation}
            onChange={handleFilterChange}
          />
          <div>
            {!columnFilter ? (
              <Icon
                className={classes.columnFilter}
                title='Show custom filtering'
                onClick={() => setColumnFilter(true)}
              >
                search
              </Icon>
            ) : (
              <Icon
                className={classes.columnFilter}
                title='Hide custom filtering'
                onClick={() => setColumnFilter(false)}
              >
                search_off
              </Icon>
            )}
          </div>
        </div>
      </div>
      <div>
        <br></br>
        {userHasDepartment && <span>Filter by: </span>}
        {user.home && (
          <>
            <label>
              <input
                type='radio'
                defaultChecked
                name='assetSelection'
                onChange={() => {
                  setAssetSelection(DepartmentParentSelection);
                }}
                value={DepartmentParentSelection}
              />{' '}
              {departmentParent?.name}
            </label>
            <label>
              <input
                id='departmentSelection'
                type='radio'
                name='assetSelection'
                onChange={() => {
                  setAssetSelection(DepartmentSelection);
                }}
                value={DepartmentSelection}
              />{' '}
              {department.name}
            </label>
            <label>
              <input
                type='radio'
                name='assetSelection'
                onChange={() => {
                  setAssetSelection(AllSelection);
                }}
                value={AllSelection}
              />{' '}
              All
            </label>
          </>
        )}
      </div>
      <AssetListSelect
        filter={filter}
        columnFilter={columnFilter}
        alreadyAddedAssets={alreadyAddedAssets}
        addAssetToManifest={onAddToManifest}
        {...{ assetsToView }}
      />
    </div>
  );
};

export default ManifestFindAssetForm;
